<template>
  <div class="pickup-members-container">
    <proa-heading v-if="!initialized || favoriteUsers.length" sub class="mt-4 pt-3 mb-3 pb-1">{{ $t('pages.mySpace.pickupMember') }}</proa-heading>
    <div class="pickup-members-wrapper">
      <div v-if="!initialized" class="loading-wrapper">
        <proa-loading class="loading"/>
      </div>
      <carousel
       :mouse-drag="$deviceInfo.isMobile"
       :navigate-to="carousel.navigateTo"
       :per-page="carousel.perPage"
       :pagination-enabled="false"
       class="pickup-members-carousel"
       ref="pickupMembersCarousel"
       @page-change="carouselPageChanged">
        <slide v-for="user in favoriteUsers" :key="user.id">
          <user-card
            :user="user"
            @click.native="setMemberModalId(user.id)"
            class="clickable"
          />
        </slide>
      </carousel>
      <div v-if="!$deviceInfo.isMobile" class="pickup-members-overlay">
        <div
          v-if="carouselBefore !== false"
          @click="onClickCarouselNavigation(carouselBefore)"
          class="pickup-members-carousel-navigation before"
        />
        <div
          v-if="carouselNext !== false"
          @click="onClickCarouselNavigation(carouselNext)"
          class="pickup-members-carousel-navigation next"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters } from 'vuex'
import User from '@/store/models/User'
import { Carousel, Slide } from 'vue-carousel'
import UserCard from '@/components/molecules/UserCard'

export default {
  name: 'MySpacePickupMembers',
  components: {
    Carousel,
    Slide,
    UserCard
  },
  computed: {
    carouselBefore: function() {
      if (this.carousel.index != 0) {
        return this.carousel.index - 1
      } else {
        return false
      }
    },
    carouselNext: function() {
      if ((this.carousel.index + 1) * this.carousel.perPage < this.favoriteUsers.length) {
        return this.carousel.index + 1
      } else {
        return false
      }
    },
    favoriteUsers: function() {
      if (!this.initialized) return []

      return this.signedInUser.favoriteUsers.slice().sort((first, second) => {
        return first.listSequenceNo - second.listSequenceNo
      }).map(favoriteUser => {
        return User.find(favoriteUser.userId)
      }).filter(favoriteUser => favoriteUser != null)
    },
    ...mapGetters({
      signedInUser: 'auth/signedInUser'
    })
  },
  data(){
    return {
      initialized: false,
      carousel: {
        index: 0,
        perPage: 0,
        navigateTo: 0
      }
    }
  },
  methods: {
    handleResize: function() {
      this.carousel.perPage = Math.floor(this.$refs.pickupMembersCarousel.$el.clientWidth / 130) || 1
    },
    carouselPageChanged: function(page) {
      this.carousel.index = Number.isFinite(page) ? page : 0
    },
    onClickCarouselNavigation: function(toPage) {
      this.carousel.navigateTo = toPage
    },
    ...mapMutations({
      setMemberModalId: 'setMemberModalId'
    }),
    ...mapActions({
      apiGetUsers: 'entities/users/index'
    })
  },
  async created () {
    if (User.query().where(user => user.id != this.signedInUser.id).get().length) this.initialized = true

    await this.apiGetUsers({
      favorites: true
    })
    this.initialized = true
  },
  mounted: function () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  beforeDestroy: function () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/mediaquery";
@import "@/styles/variables";

.loading-wrapper {
  min-height: 154px;
  display: flex;
  align-items: center;
  justify-content: center;

  .loading {
    width: 80px;
    height: 80px;
  }
}

.pickup-members-container {
  padding-bottom: 2px;
}

.pickup-members-wrapper {
  position: relative;
}

.pickup-members-carousel {
  width: calc(100vw - 20px);

  @include mq(lg) {
    width: calc(100vw - 240px);
  }
}

.pickup-members-overlay {
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;

  .pickup-members-carousel-navigation {
    width: 50px;
    height: 50px;
    background: $primary-color;
    opacity: 0.3;
    border-radius: 50%;
    cursor: pointer;
    pointer-events: auto;
    position: absolute;
    top: calc(50% - 25px);
    color: white;

    &:hover {
      opacity: 1;
    }

    &::before {
      content:  '';
      width: 12px;
      height: 12px;
      display:  block;
      border-top: solid 1px;
      border-right: solid 1px;
      position: absolute;
    }

    &.before {
      &::before {
        transform: rotate(225deg);
        top: calc(25px - 6px);
        left: calc(25px - 4px);
      }
    }

    &.next {
      right: 0;

      &::before {
        transform: rotate(45deg);
        top: calc(25px - 6px);
        left: calc(25px - 9px);
      }
    }
  }
}
</style>
